import api from './apiService';

export const addEventAttendees = async (eventId, userIds) => {
    const response = await api.post(`/events/${eventId}/attendees`, { user_ids: userIds });
    return response.data;
};

export const updateAttendanceStatus = async (eventId, userId, status) => {
    const response = await api.put(`/events/${eventId}/attendees/${userId}`, { status });
    return response.data;
};

export const removeEventAttendee = async (eventId, userId) => {
    const response = await api.delete(`/events/${eventId}/attendees/${userId}`);
    return response.data;
};
